import CancelButton from "Common/Components/Buttons/CancelButton";
import ArrowBack from "@mui/icons-material/ArrowBack";
import LoadingSpinner from "Common/Components/LoaderErrorWrapper/LoadingSpinner";
import FormattedDate from "Common/Components/NameWithDate.tsx/FormattedDate";
import PageContainer from "Common/Components/PageContainer/PageContainer";
import StatusBadge from "Common/Components/StatusBadge/StatusBadge";
import { AttachmentList } from "components/DocumentListing/AttachmentListing";
import { DocumentsList } from "components/DocumentListing/DocumentListing";
import Colors, { MecordColors } from "Constants/Color";
import { Fragment, useEffect, useState } from "react";
import { Card, Col, Row, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchPurchaseRequestId } from "slices/Procurement/purchase-request/thunk";
import Tooltip from "@mui/material/Tooltip";
import { formatIndianAmount } from "helpers/formatIndianAmount";

const PurchaseRequestViewDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { pr_id } = useParams();
  const [data, setData] = useState<any>({});
  const [pageLoading, setPageLoading] = useState<boolean>(false);

  useEffect(() => {
    setPageLoading(true);
    if (pr_id) {
      dispatch(fetchPurchaseRequestId(pr_id))
        .unwrap()
        .then((res: any) => {
          console.log("res : ", res);
          setData(res.data);
          setPageLoading(false);
        })
        .catch((e: any) => {
          toast.error(e || "somthing went wrong");
          setPageLoading(false);
        })
        .finally(() => {
          setPageLoading(false);
        });
    }
  }, [pr_id, dispatch]);

  const displayValue = (val: any) => val || "-";

  return (
    <Fragment>
      <PageContainer>
        <div className="d-flex align-items-center">
          <ArrowBack
            className="me-2"
            style={{ fontSize: "1.25rem", cursor: "pointer" }}
            onClick={() => navigate(-1)}
          />
          <h6 className="card-title mb-0">View Purchase Request</h6>
        </div>
        <hr />

        {pageLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <Row className="mb-3">
              <Col md={6}>
                <p className="mb-3">
                  <strong>PR No. :</strong> {displayValue(data?.pr_no)}
                </p>
              </Col>
              <Col md={6}>
                <p className="mb-3">
                  <strong>PR Status :</strong>{" "}
                  <StatusBadge
                    status={data?.status || "Pending"}
                    bgColor={
                      data?.status === "Approved"
                        ? Colors.bg_success
                        : data?.status === "Rejected"
                          ? Colors.bg_damage
                          : data?.status === "PO Created"
                            ? Colors.bg_blue
                            : data?.status === "Partial PO Created"
                              ? "#6366F1"
                              : Colors.bg_yellow
                    }
                    color="#fff"
                  />
                </p>
              </Col>
              <Col md={6}>
                <p className="mb-3">
                  <strong>PR Date :</strong>{" "}
                  <FormattedDate date={data?.pr_date} />
                </p>
              </Col>
              <Col md={6}>
                <p className="mb-3">
                  <strong>Initiated By :</strong> {data?.initiated_by || "-"}
                </p>
              </Col>
              <Col md={6}>
                <p className="mb-3">
                  <strong>Tags :</strong>{" "}
                  {Array.isArray(data?.tags) && data.tags.length > 0 ? (
                    <span className="d-flex flex-wrap gap-2 mt-1">
                      {data.tags.map((tag: string) => (
                        <span
                          key={tag}
                          className="badge bg-light text-dark rounded-2"
                          style={{
                            border: "1px solid #dee2e6",
                            padding: "6px 10px",
                            fontSize: "0.8rem",
                          }}
                        >
                          {tag}
                        </span>
                      ))}
                    </span>
                  ) : (
                    "-"
                  )}
                </p>
              </Col>
            </Row>

            <div className="mb-4">
              <h6 className="fw-semibold mb-2" style={{ fontSize: "0.9rem" }}>
                Products
              </h6>
              <Card
                style={{
                  boxShadow: "none",
                  // border: "1px solid #dee2e6",
                  backgroundColor: MecordColors?.LightThemeBGColor,
                }}
              >
                <Card.Body className="m-0 p-3">
                  <div style={{ overflowX: "auto" }}>
                    <table className="table align-middle">
                      <thead
                        style={{
                          backgroundColor: MecordColors.LightGrayColor,
                        }}
                      >
                        <tr>
                          <th style={{ minWidth: "60px" }}>Sr No.</th>
                          <th style={{ minWidth: "180px" }}>Product Name</th>
                          <th style={{ minWidth: "120px" }}>Product Code</th>
                          <th style={{ minWidth: "100px" }}>Quantity</th>
                          <th style={{ minWidth: "120px" }}>Unit</th>
                          <th style={{ minWidth: "120px" }}>Unit Price</th>
                          <th style={{ minWidth: "120px" }}>Amount</th>
                          <th style={{ minWidth: "100px" }}>Status</th>
                          <th style={{ minWidth: "180px" }}>Description</th>
                        </tr>
                      </thead>
                      <tbody style={{ backgroundColor: "#ffffff" }}>
                        {data?.products?.map((item: any, i: number) => {
                          const productName =
                            item?.product?.product_name ||
                            item?.product_details?.product_name ||
                            "-";
                          const unitName =
                            item?.product?.unit?.unit_name ||
                            item?.product_details?.unit_name ||
                            "-";
                          const qty = Number(item?.quantity) || 0;
                          const unitPrice = Number(item?.unit_price) || 0;
                          const amount = qty * unitPrice;
                          return (
                            <tr key={item?.pr_product_id || i}>
                              <td>{i + 1}</td>
                              <td>{displayValue(productName)}</td>
                              <td>{displayValue(item?.product_code)}</td>
                              <td>{displayValue(item?.quantity)}</td>
                              <td>{displayValue(unitName)}</td>
                              <td>{formatIndianAmount(unitPrice)}</td>
                              <td>{formatIndianAmount(amount)}</td>
                              <td>
                                <StatusBadge
                                  status={item?.status || "Pending"}
                                  bgColor={
                                    item?.status === "PO Created"
                                      ? Colors.bg_blue
                                      : item?.status === "Partial PO Created"
                                        ? "#6366F1"
                                        : Colors.bg_yellow
                                  }
                                  color="#fff"
                                />
                              </td>
                              <td>
                                <Tooltip
                                  title={item?.description || ""}
                                  arrow
                                  placement="top"
                                >
                                  <span
                                    style={{
                                      maxWidth: "200px",
                                      display: "inline-block",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      verticalAlign: "middle",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {displayValue(item?.description)}
                                  </span>
                                </Tooltip>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {(!data?.products || data.products.length === 0) && (
                      <p className="text-muted text-center py-4 mb-0">
                        No products added
                      </p>
                    )}
                  </div>
                </Card.Body>
              </Card>
            </div>

            {(data?.status === "Approved" ||
              data?.approved_by ||
              data?.approved_date ||
              data?.pr_approval_remark) && (
              <div className="mb-4">
                <h6
                  className="fw-semibold mb-2"
                  style={{ fontSize: "0.9rem" }}
                >
                  Approval Details
                </h6>
                <Card
                  style={{
                    boxShadow: "none",
                    // border: "1px solid #dee2e6",
                    backgroundColor: MecordColors?.LightThemeBGColor,
                  }}
                >
                  <Card.Body>
                    <Row>
                      <Col md={6}>
                        <p className="mb-2">
                          <strong>Reviewed By :</strong>{" "}
                          {displayValue(
                            data?.approved_by_user?.first_name ||
                              data?.approved_by_user?.username ||
                              data?.approved_by,
                          )}
                        </p>
                      </Col>
                      <Col md={6}>
                        <p className="mb-2">
                          <strong>Reviewed Date :</strong>{" "}
                          {data?.approved_date ? (
                            <FormattedDate date={data.approved_date} />
                          ) : (
                            "-"
                          )}
                        </p>
                      </Col>
                      <Col md={12}>
                        <p className="mb-0">
                          <strong>Review Remark :</strong>{" "}
                          {displayValue(data?.pr_approval_remark)}
                        </p>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </div>
            )}

            <Row>
              <Col md={6}>
                <p className="mb-3">
                  <strong>Notes :</strong> 
                  <div style={{marginLeft:"10px", whiteSpace: "pre-wrap"}}>{displayValue(data?.notes)}</div>
                </p>
              </Col>

              <Col md={6}>
                <strong>PR Attachments :</strong>

                 <AttachmentList attachments={data.attachments} />

                {/* {data?.attachments &&
                Array.isArray(data.attachments) &&
                data.attachments.length > 0 ? (
                  <DocumentsList files={data.attachments} />
                ) : (
                  <p className="mt-2 text-muted">Document Not Uploaded</p>
                )} */}
              </Col>
            </Row>

            <div className="d-flex flex-column flex-md-row justify-content-center gap-3 mt-3">
              <CancelButton
                onClick={() => navigate(-1)}
                disabled={pageLoading}
                showConfirmation={false}
              />
            </div>
          </>
        )}
      </PageContainer>
    </Fragment>
  );
};

export default PurchaseRequestViewDetails;
